const POSITION_HEADLINE: Record<string, string> = {
  approved: "Approved this version.",
  changes_requested: "Requested changes on this version.",
};

const APPROVAL_SUGGESTED_HEADLINE =
  "Puntt suggested a reviewer for this version.";

/** Parse legacy feed bodies that inlined reasoning after a colon. */
export function reasoningFromFeedBody(body: string | undefined): string | null {
  const trimmed = body?.trim();
  if (!trimmed) return null;
  const match = trimmed.match(/^Puntt suggested a reviewer:\s*(.+)$/i);
  return match?.[1]?.trim() || null;
}
export function noteFromFeedBody(
  body: string | undefined,
  position: string | null,
  eventType: string,
): string | null {
  const trimmed = body?.trim();
  if (!trimmed) return null;

  if (position === "approved") {
    const match = trimmed.match(/^Approved this version:\s*(.+)$/i);
    if (match?.[1]?.trim()) return match[1].trim();
  }
  if (position === "changes_requested") {
    const match = trimmed.match(/^Requested changes:\s*(.+)$/i);
    if (match?.[1]?.trim()) return match[1].trim();
  }
  if (eventType === "approval_note") {
    const match = trimmed.match(/^Left a note:\s*(.+)$/i);
    if (match?.[1]?.trim()) return match[1].trim();
  }
  return null;
}

export function resolveFeedApprovalNote(
  payload: Record<string, unknown>,
  body: string | undefined,
  position: string | null,
  eventType: string,
): string | null {
  const fromPayload =
    typeof payload.notePreview === "string"
      ? payload.notePreview
      : typeof payload.noteBody === "string"
        ? payload.noteBody
        : null;
  if (fromPayload?.trim()) return fromPayload.trim();
  return noteFromFeedBody(body, position, eventType);
}

export function resolveFeedApprovalHeadline(
  eventType: string,
  body: string | undefined,
  position: string | null,
): string {
  if (eventType === "approval_suggested") {
    return APPROVAL_SUGGESTED_HEADLINE;
  }
  if (eventType === "position_recorded" && position) {
    return (
      POSITION_HEADLINE[position] ?? body?.trim() ?? "Participation update"
    );
  }
  if (eventType === "approval_note") {
    return body?.trim() || "Left a reviewer note.";
  }
  return body?.trim() || "Participation update";
}

export function resolveFeedApprovalReasoning(
  payload: Record<string, unknown>,
  body: string | undefined,
  eventType: string,
): string | null {
  const fromPayload =
    typeof payload.reasoning === "string" ? payload.reasoning.trim() : "";
  if (fromPayload) return fromPayload;
  if (eventType === "approval_suggested") {
    return reasoningFromFeedBody(body);
  }
  return null;
}
